import { AppLayout } from '../components/UI/AppLayout/AppLayout'

export const DictationPage = () => {
    return <AppLayout/>
}

